import React from 'react';

import classes from './NavbarElement.module.css';

const navbarElement = (props) => {
  return (
    <button className={classes.NavbarElement} onClick={props.clicked}>
      <svg fill={props.fill || 'var(--svg-color-navigation)'} className={classes.IconSvg}>
        <use xlinkHref={props.imgIcon} />
      </svg>
    </button>
  );
};

export default navbarElement;
